<template>
  <div class="home-page">
    <Header />

    <main class="content">
      <div class="update-badge">2026年04月08日 最新算法已更新</div>

      <div class="baokuantitle">
        <span style="
          background: linear-gradient(135deg, #6366f1 0%, #a855f7 100%);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
        ">爆款标题</span>生成器
      </div>

      <p class="description">
        利用最先进的语义理解模型，一键生成高赞标题。覆盖主流社交平台，精准拿捏流量密码，让你的内容瞬间出圈。
      </p>

      <FeatureTags />
      <TitleGenerator />

      <!-- 订阅卡片 -->
      <UserSubscription />
    </main>

    <Footer />
  </div>
</template>

<script>
import Header from '../components/Header.vue'
import TitleGenerator from '../components/TitleGenerator.vue'
import FeatureTags from '../components/FeatureTags.vue'
import Footer from '../components/Footer.vue'
import UserSubscription from '../components/UserSubscription.vue'
import { getSubscriptionHistory } from '@/api/vip'

// 引入 vuex
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'HomeView',
  components: {
    Header,
    TitleGenerator,
    FeatureTags,
    Footer,
    UserSubscription
  },
  data() {
    return {
      // 不再本地存储，从 vuex 取
    }
  },
  created() {
  },
  methods: {

  }
}
</script>

<style scoped>
.home-page {
  width: 100%;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

.content {
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
  flex: 1;
  padding: 20px;
  color: #333;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.update-badge {
  margin: 50px 0 0 0;
  padding: 8px 16px;
  font-weight: 500;
  font-size: 1.3rem;
  color: rgb(67 56 202);
  background-color: rgb(238 242 255);
  border-radius: 9999px;
}

.baokuantitle {
  text-align: center;
  margin: 30px 0;
  font-size: 72px;
  line-height: 1;
  font-weight: 700;
  background: rgb(16, 24, 81);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.description {
  font-size: 1.25rem;
  line-height: 1.625;
  margin-bottom: 2.5rem;
  max-width: 42rem;
  text-align: center;
  color: rgb(71 85 105);
}

@media (max-width: 820px) {
  .update-badge {
    font-size: 0.9rem;
  }

  .baokuantitle {
    font-size: 47px;
  }

  .description {
    font-size: 14px;
  }
}
</style>